import React from 'react'
import "../styles/slides.css"

const Advert = () => {
  return (
    <div>
<div className="slider shj rig">
	<div className="slide-track k">
		<div className="slide h ">
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/1.png" height="100" width="250" alt="" /> */}
            <div className="ccl ch2">Join us on 15th November,2024 for Adane’s launch! <span style={{color:"#fff",margin:"0 10px"}} > | </span> Create projects easily and earn rewards by referring new clients.</div>
		</div>
		<div className="slide h">
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/2.png" height="100" width="250" alt="" /> */}
             <div  className="ccl ch2">Join us on 15th November,2024 for Adane’s launch!  <span style={{color:"#fff",margin:"0 10px"}} > | </span> Create projects easily and earn rewards by referring new clients.</div>
		</div>
		<div className="slide h">
             <div  className="ccl ch2">Join us on 15th November,2024 for Adane’s launch!  <span style={{color:"#fff",margin:"0 10px"}} > | </span>Create projects easily and earn rewards by referring new clients.</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/3.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide h">
             <div  className="ccl ch2">Join us on 15th November,2024 for Adane’s launch! <span style={{color:"#fff",margin:"0 10px"}} > | </span> Create projects easily and earn rewards by referring new clients.</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/4.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide h">
             <div  className="ccl ch2">Join us on 15th November,2024 for Adane’s launch! <span style={{color:"#fff",margin:"0 10px"}} > | </span> Create projects easily and earn rewards by referring new clients.</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/5.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide h">
             <div  className="ccl ch2">Join us on 15th November,2024 for Adane’s launch! <span style={{color:"#fff",margin:"0 10px"}} > | </span> Create projects easily and earn rewards by referring new clients.</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/6.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide h">
             <div  className="ccl ch2">Join us on 15th November,2024 for Adane’s launch! <span style={{color:"#fff",margin:"0 10px"}} > | </span> Create projects easily and earn rewards by referring new clients.</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/7.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide h">
             <div  className="ccl ch2">Join us on 15th November,2024 for Adane’s launch! <span style={{color:"#fff",margin:"0 10px"}} > | </span> Create projects easily and earn rewards by referring new clients.</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/1.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide h">
             <div  className="ccl ch2">Join us on 15th November,2024 for Adane’s launch!  <span style={{color:"#fff",margin:"0 10px"}} > | </span>Create projects easily and earn rewards by referring new clients.</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/2.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide h">
             <div  className="ccl ch2">Join us on 15th November,2024 for Adane’s launch! <span style={{color:"#fff",margin:"0 10px"}} > | </span> Create projects easily and earn rewards by referring new clients.</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/3.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide h">
             <div  className="ccl ch2">Join us on 15th November,2024 for Adane’s launch! <span style={{color:"#fff",margin:"0 10px"}} > | </span> Create projects easily and earn rewards by referring new clients.</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/4.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide h">
             <div  className="ccl ch2">Join us on 15th November,2024 for Adane’s launch! <span style={{color:"#fff",margin:"0 10px"}} > | </span> Create projects easily and earn rewards by referring new clients.</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/5.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide h">
             <div  className="ccl ch2">Join us on 15th November,2024 for Adane’s launch! <span style={{color:"#fff",margin:"0 10px"}} > | </span> Create projects easily and earn rewards by referring new clients.</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/6.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide h">
             <div  className="ccl ch2">Join us on 15th November,2024 for Adane’s launch!  <span style={{color:"#fff",margin:"0 10px"}} > | </span>Create projects easily and earn rewards by referring new clients.</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/7.png" height="100" width="250" alt="" /> */}
		</div>
	</div>
</div>

    </div>
  )
}

export default Advert